<template>
	<header-menu-admin />

	<section class="error-section py-40" v-if="!coupon && !loading">
		<div class="container-fluid">
			<div class="error-wrapper text-center py-40 bg-white br-10">
				<h1 class="mb-32">404</h1>
				<h5 class="mb-16"><span class="color-primary">Упс!</span> Что-то пошло не так...</h5>
				<p class="light-gray mb-32">Купон не найден.<br/>Возможно он был удален либо никогда не существовал.</p>
				<router-link :to="{path: '/admin/coupons'}" class="cus-btn">В список купонов</router-link>
			</div>
		</div>
	</section>
	
	<div v-else>
		<!-- Main Sections -->
		<main class="main-wrapper bg-lightest-gray">

			<!-- About Section Start -->
			<section class="about-section py-40">
				<div class="container-fluid">
					<div class="top-bar mb-16">
						<router-link :to="{path: '/admin/coupons'}" class="btn btn-secondary">
							Назад
						</router-link>
					</div>
					<div class="about-wrapper bg-white">
						<div class="about-block">
							<h4 class="mb-12">Изменение купона</h4>
							<form @submit.prevent="onCouponEdit" class="contact-form">
								<div class="row">
									<div class="col-md-6">
										<div class="input-block mb-16">
											<label for="code" class="form-label">Код купона:</label>
											<input type="text" id="code" class="form-control" placeholder="Код купона" v-model="code" required>
										</div>
									</div>
									<div class="col-md-6">
										<div class="input-block mb-16">
											<label for="discount" class="form-label">Сумма сикдки:</label>
											<input type="number" id="discount" @wheel="$event.target.blur()" class="form-control noscroll" min="1" v-model.number="discount" required>
										</div>
									</div>
									<div class="col-md-6">
										<button type="submit" class="btn btn-primary" :disabled="btnDisabled">Сохранить изменения</button>
									</div>
									<div class="col-md-6 text-end">
										<button type="button" class="btn btn-outline-danger" @click="onDelete">Удалить</button>
									</div>
								</div>
							</form>
							<div class="alert alert-warning alert-dismissible mt-3 mb-0" role="alert" v-if="error">
								{{error}}
								<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
							</div>
						</div>
					</div>
				</div>
			</section>
			<!-- About Section End -->
		</main>
		<!-- Main Sections -->
	</div>
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import HeaderMenuAdmin from '@/components/HeaderMenuAdmin';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech Admin'});
	},
	data: () => ({
		coupon: null,
		code: '',
		discount: 0,
		
		loading: true,
		error: '',
		btnDisabled: false,
	}),
	methods: {
		async loadCoupon(){
			this.loading = true;
			this.appModel.preloader = true;
			
			const ret = await this.appModel.doGetCoupon(this.$route.params.id);
			if(ret.success){
				this.coupon = ret.item;
				this.code = this.coupon?.code||'';
				this.discount = this.coupon?.discount||'';
			}
			
			setTimeout(() => {
				this.loading = false;
				this.appModel.preloader = false;
			}, 1000);
		},
		async onCouponEdit(){
			this.error = '';
			this.btnDisabled = true;
			
			const params = {
				code: this.code,
				discount: this.discount,
			};
			let ret = await this.appModel.doEditCoupon(this.$route.params.id, params);
			this.btnDisabled = false;
			if(ret.success){
				ret = await this.appModel.doGetCoupons();
				if(ret.success) {
					this.appModel.coupons = ret.list;
				}
			} else {
				this.error = ret.error;
			}
		},
		async onDelete(){
			if(confirm('Вы уверены, что хотите удалить данный купон?')){
				let ret = await this.appModel.doDeleteCoupon(this.$route.params.id);
				if(ret.success){
					ret = await this.appModel.doGetCoupons();
					if(ret.success) {
						this.appModel.coupons = ret.list;
					}
					
					this.$router.push('/admin/coupons');
				} else {
					alert(ret.error);
				}
			}
		},
	},
	async mounted(){
		window.scrollTo(0, 0);
		
		await this.loadCoupon();
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		HeaderMenuAdmin,
	},
};
</script>